/* HomeBarComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./HomeBarRenderer");
const _ = require("lodash");
const SOLUTION_TITLE = {
    Dashboard: "My Dashboards",
    RoboHelp: "Help",
};
const SOLUTION_USER_PERM_MAP = require("../SolutionPermsMap");

class HomeBarComponent extends EventEmitter {
    constructor(configOptions) {
        super();
        this._steve = _.get(configOptions, "steve", undefined);
        this._name = _.get(configOptions, "name", "");
        this._nameArr = _.get(configOptions, "nameArray", ["", ""]); // Array with first and last names <[first, last]>
        this._email = _.get(configOptions, "email", "");
        this._role = _.get(configOptions, "role", undefined);
        this._userImage = _.get(configOptions, "profileImage", undefined);
        this._icon = _.get(configOptions, "icon", "branding.control");
        this._userName = _.get(configOptions, "userId", "");
        this._title = _.get(configOptions, "title", "");
        this._iconNotActionable = _.get(configOptions, "iconNotActionable", false);
        this._organizations = _.get(configOptions, "organizations", []);
        this._projects = _.get(configOptions, "projects", []);
        this._organizationsDisabled = _.get(configOptions, "organizationsDisabled", false);
        this._projectsDisabled = _.get(configOptions, "projectsDisabled", false);
        this._menuDisabled = _.get(configOptions, "menuDisabled", false);
        this._activeOrganization = _.get(configOptions, "activeOrganization", undefined);
        this._activeProject = _.get(configOptions, "activeProject", undefined);
        this._solutionManager = _.get(configOptions, "solutionManager", undefined);
        this._storageFactory = _.get(configOptions, "storageFactory", undefined);

        this._buildVerticalMenuDebounced = _.debounce(
            this._buildVerticalMenuDebounced.bind(this),
            500
        );

        this._userData = undefined;
        this._controlUserEntity = undefined;

        this._disabled = _.get(configOptions, "disabled", false);
        this._shown = _.get(configOptions, "shown", true);

        this._versioControlCount = 0;

        this._buildVerticalMenuStart = _.debounce(this._buildVerticalMenuStart.bind(this), 200);

        this._licenseRestriction = undefined;

        this._userAuthorizedActions = undefined;

        this._showVersionControl = false;

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerLicenseListeners() {
        if (this._licenseRestriction) {
            this._unregisterLicenseListeners();
            this._licenseRestriction.on(
                "Data",
                (this._onLicensesUpdated = this._onLicensesUpdated.bind(this))
            );
        }
    }

    _unregisterLicenseListeners() {
        if (this._licenseRestriction) {
            this._licenseRestriction.removeAllListeners("Data");
        }
    }

    _onLicensesUpdated() {
        this.refresh();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get icon() {
        return this._icon;
    }

    /** BEGIN - Steve ************************/

    get steve() {
        return this.getSteve();
    }

    getSteve() {
        return this._steve;
    }

    /** END - Steve ************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterLicenseListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;

        this._name = undefined;
        this._nameArr = undefined;
        this._email = undefined;
        this._role = undefined;
        this._title = undefined;
        this._organizations = undefined;
        this._projects = undefined;
        this._menuDisabled = undefined;
        this._organizationsDisabled = undefined;
        this._projectsDisabled = undefined;
        this._activeOrganization = undefined;
        this._activeProject = undefined;
        this._disabled = undefined;
        this._shown = undefined;
        this._userData = undefined;
        this._userImage = undefined;
        this._genAiGluwareService = undefined;
        this._versionControlCount = undefined;
        this._showVersionControl = undefined;

        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _triggerOrganizationChange(newOrganization, oldOrganization, event) {
        this.emit("OrganizationChange", newOrganization, oldOrganization, event);
        this._buildVerticalMenuDebounced();
    }

    _buildVerticalMenuDebounced() {
        this.emit("buildVerticalMenu");
        this.emitInitialValues();
    }

    _triggerProjectChange(newProject, oldProject, event) {
        this.emit("ProjectChange", newProject, oldProject, event);
    }

    _triggerTitleSelected(event) {
        this.emit("TitleSelected", event);
    }

    _triggerHelpSelected(event) {
        this.emit("HelpSelected", event);
    }

    _triggerMenuSelected(event) {
        this.emit("MenuSelected", event);
    }

    _triggerLogOutSelected(event) {
        this.emit("LogOutSelected", event);
    }

    _triggerAutoShow(event) {
        this.emit("AutoShow", event);
    }

    _triggerAutoHide(event) {
        this.emit("AutoHide", event);
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setAIChat(genAiGluwareService = undefined) {
        if (genAiGluwareService) {
            this._genAiGluwareService = genAiGluwareService;
        }
        this.emit("AIChat");
    }

    setGenAIGluwareService(service) {
        this._genAiGluwareService = service;
    }

    setUserImage(newVal) {
        this._userImage = newVal;
        this.emit("UserImage", this._userImage);
        return this;
    }

    getUserImage() {
        return this._userImage;
    }

    setUserId(userId) {
        this._userName = userId;
        this.emit("UserId", this._userName);
    }

    setVersionControlCount(val) {
        this._versionControlCount = val;
        this.emit("VersionControlCount", this._versionControlCount);
    }

    setName(newVal, arr) {
        this._name = newVal ? newVal : this._name;
        this._nameArr = arr ? arr : this._nameArr;
        this.emit("Name", this._name, this._nameArr);
        return this;
    }

    getName() {
        return this._name;
    }

    getNameArray() {
        return this._nameArr;
    }

    setTitle(newVal) {
        this._title = newVal;
        this.emit("Title", this._title);
        return this;
    }

    getTitle() {
        if (
            this._title === "" &&
            this._solutionManager &&
            _.get(this._solutionManager._router.getRouteDetails(), "s", false)
        ) {
            const solutionName = _.get(this._solutionManager._router.getRouteDetails(), "s");
            if (SOLUTION_TITLE[solutionName]) {
                this.setTitle(SOLUTION_TITLE[solutionName]);
                return this._title;
            }
        }
        return this._title;
    }

    setIcon(newVal) {
        this._icon = newVal;
        this.emit("Icon", this._icon);
        return this;
    }

    getIcon() {
        return this._icon;
    }

    setIconNotActionable(newVal) {
        this._iconNotActionable = newVal;
        this.emit("IconNotActionable", this._iconNotActionable);
        return this;
    }

    getIconNotActionable() {
        return this._iconNotActionable;
    }

    setEmail(newVal) {
        this._email = newVal;
        this.emit("Email", this._email);
        return this;
    }

    getEmail() {
        return this._email;
    }

    setRole(newVal) {
        this._role = newVal;
        this.emit("Role", this._role);
        return this;
    }

    getRole() {
        return this._role;
    }

    showVersionControl(newVal = false) {
        this._showVersionControl = newVal;
        this.emit("ShowVersionControl", this._showVersionControl);
        return this;
    }

    showItemsBasedOnXDome(newVal = false) {
        this._showXDomeMenuItems = newVal;
        this.emit("ShowItemsBasedOnXDome", this._showXDomeMenuItems);
        return this;
    }

    isVersionControlVisible() {
        return this._showVersionControl;
    }

    setOrganizations(newVal) {
        this._organizations = newVal;
        this.emit("Organizations", this._organizations);
        return this;
    }

    getOrganizations() {
        return this._organizations;
    }

    setActiveOrganization(newVal) {
        this._activeOrganization = newVal;
        this.emit("ActiveOrganization", this._activeOrganization);
        return this;
    }

    getActiveOrganization() {
        return this._activeOrganization;
    }

    setProjects(newVal) {
        this._projects = newVal;
        this.emit("Projects", this._projects);
        return this;
    }

    getProjects() {
        return this._projects;
    }

    setActiveProject(newVal) {
        this._activeProject = newVal;
        this.emit("ActiveProject", this._activeProject);
        return this;
    }

    getActiveProject() {
        return this._activeProject;
    }

    setDisabled(newVal) {
        this._disabled = newVal;
        this.emit("Disabled", this._disabled);
        return this;
    }

    getDisabled() {
        return this._disabled;
    }

    setMenuDisabled(newVal) {
        this._menuDisabled = newVal;
        this.emit("MenuDisabled", this._menuDisabled);
        return this;
    }

    getMenuDisabled() {
        return this._menuDisabled;
    }

    setOrganizationsDisabled(newVal) {
        this._organizationsDisabled = newVal;
        this.emit("OrganizationsDisabled", this._organizationsDisabled);
        return this;
    }

    getOrganizationsDisabled() {
        return this._organizationsDisabled;
    }

    setProjectsDisabled(newVal) {
        this._projectsDisabled = newVal;
        this.emit("ProjectsDisabled", this._projectsDisabled);
        return this;
    }

    getProjectsDisabled() {
        return this._projectsDisabled;
    }

    get solutionManager() {
        return this._solutionManager;
    }

    setUserData(user) {
        this._userData = user;
        this._userAuthorizedActions = _.get(this._userData, "authorizedActions", undefined);
        if (this._userAuthorizedActions) {
            this.emit("UserAuthorizeActions");
        }
        if (_.get(this._solutionManager, "_di").getRegistered("$teve.licenseRestriction")) {
            this._licenseRestriction = _.get(this._solutionManager, "_di").getRegistered(
                "$teve.licenseRestriction"
            ).registeredObj;

            this._registerLicenseListeners();
        }
        // this.emit("UserDataSet");
    }

    getUserAuthorizedActions() {
        return this._userAuthorizedActions || [];
    }

    setControlUser(controlUser) {
        this._controlUserEntity = controlUser;

        if (
            _.get(this._activeOrganization, "id", " ") !==
            this._controlUserEntity.getProperty("lastTenantId")
        ) {
            this._controlUserEntity.setProperty(
                "lastTenantId",
                _.get(this._activeOrganization, "id", "")
            );
            this._controlUserEntity.update();
        }

        this.emit("ControlUserSet");
    }

    setGenAiVisibleAndEnable(genAiVisible, genAiEnabled) {
        this._genAiVisible = genAiVisible;
        this._genAiEnabled = genAiEnabled;
        this.emit("GenAiVisibleAndEnable");
    }

    get licenseRestriction() {
        return this._licenseRestriction;
    }

    setIsCatalogEnabled(catalogEnable) {
        this._enableCatalogs = catalogEnable;
    }

    emitInitialValues() {
        this.emit("ApplyInitialValues");
    }

    hideGrid() {
        this.emit("HideGrid");
        return this;
    }

    focus() {
        this.emit("Focus");
        return this;
    }

    blur() {
        this.emit("Blur");
        return this;
    }

    show() {
        this.emit("Shown", true);
        return this;
    }

    hide() {
        this.emit("Shown", false);
        return this;
    }

    clearState() {
        this.setName("");
        this.setTitle(this._title);
        this.setIcon(this._icon);
        this.setEmail("");
        this.setRole("");
        this.setActiveOrganization(undefined);
        this.setOrganizations([]);
        this.setActiveProject(undefined);
        this.setProjects([]);
        this.setMenuDisabled(false);
        this.setOrganizationsDisabled(false);
        this.setProjectsDisabled(false);
        return this;
    }

    closeChatWindow(endSession, unmountChat) {
        this.emit("CloseChat", {endSession, unmountChat});
    }

    _buildVerticalMenuStart() {
        this.emit("buildVerticalMenu");
    }

    checkIfRestricted(solution) {
        let isLicenseRestricted = true,
            isUserRestricted = true;

        if (this._userAuthorizedActions && this._licenseRestriction) {
            isLicenseRestricted = this._licenseRestriction.checkLicense(solution.license);
            if (solution.name === "system_settings") {
                isUserRestricted = false;
            } else {
                const userPermIndex = this._userAuthorizedActions.indexOf(
                    SOLUTION_USER_PERM_MAP[solution.name]
                );
                isUserRestricted = userPermIndex >= 0 ? false : true;
            }
            return !(isLicenseRestricted && !isUserRestricted);
        }
    }

    refresh() {
        this.emit("refresh");
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = HomeBarComponent;
